import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element)
    this.modal.show()
    this.element.addEventListener("hidden.bs.modal", this.clearFrame)
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.clearFrame)

    if (this.modal) {
      this.modal.hide()
      this.modal.dispose()
    }

    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
  }

  clearFrame = () => {
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.innerHTML = ""
  }
}
